module.exports = __webpack_public_path__ + "img/carbon_time.41bd387c.svg";